export default function formatDateString(dateStr?: string): string {
  console.log('DATA STRING', dateStr);
  if (!dateStr) {
    return '';
  }

  // Remove espaços extras
  const trimmedDate = dateStr.replace(/\s+/g, ' ').trim();

  // Ajustar para formato aceito pelo Date (substituir "PM"/"AM" por espaço)
  const formattedDate = trimmedDate.replace(/(AM|PM)/, ' $1');

  // Criar uma data a partir da string formatada
  const date = new Date(formattedDate);
  console.log('DATA', date);

  if (isNaN(date.getTime())) {
    return '';
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}
